import { themeVars as e } from "./theme.js";
const i = {
  small: "1px",
  medium: "2px",
  large: "4px"
}, a = {
  none: "0",
  primary: `${e.interactive.outline.primary.enabled} solid ${i.small}`,
  primaryHover: `${e.interactive.outline.primary.hover} solid ${i.small}`,
  primaryPressed: `${e.interactive.outline.primary.pressed} solid ${i.small}`,
  primaryDisabled: `${e.interactive.outline.primary.disabled} solid ${i.small}`,
  error: `${e.interactive.fill.bad.enabled} solid ${i.small}`,
  secondary: `${e.interactive.outline.secondary.enabled} solid ${i.small}`,
  secondaryHover: `${e.interactive.outline.secondary.hover} solid ${i.small}`,
  secondaryPressed: `${e.interactive.outline.secondary.pressed} solid ${i.small}`,
  secondaryDisabled: `${e.interactive.outline.secondary.disabled} solid ${i.small}`,
  secondaryInner: "0 -1px 0 0 rgba(0, 0, 0, 0.1) inset",
  divider: `${e.static.divider.default} solid ${i.small}`,
  dividerWeak: `${e.static.divider.weak} solid ${i.small}`,
  dividerStrong: `${e.static.divider.strong} solid ${i.small}`
}, l = {
  0: "0",
  2: "2px",
  3: "3px",
  4: "4px",
  5: "5px",
  6: "6px",
  8: "8px",
  10: "10px",
  12: "12px",
  16: "16px",
  23: "23px",
  round: "999px",
  inherit: "inherit"
};
export {
  l as borderRadii,
  i as borderWidths,
  a as borders
};
//# sourceMappingURL=borders.js.map
